export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION';
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION';
export const REMOVE_SUBSCRIPTION = 'REMOVE_SUBSCRIPTION';
export const CLEAR_SUBSCRIPTION = 'CLEAR_SUBSCRIPTION';
export const CLEAR_SUBSCRIPTIONS = 'CLEAR_SUBSCRIPTIONS';
